import type { ButtonType } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";

import { i18nFilter } from "app/filters/i18nFilter";
import type { ReactNode } from "react";
import type React from "react";
import { openContactUsModal } from "app/services/ModalService";

interface IContactUsButtonProps {
    label: string; // Name of parent component (e.g. "Trial Banner")
    className?: string;
    text?: string;
    buttonType?: ButtonType;
    style?: React.CSSProperties;
    onClick?: () => void;
    children?: ReactNode;
}

const ContactUsButton: React.FunctionComponent<IContactUsButtonProps> = (props) => {
    const { className, text, label, buttonType, style, children, onClick } = props;

    return (
        <Button
            className={className}
            type={buttonType || "upsell"}
            style={{
                lineHeight: "normal",
                ...style,
            }}
            onClick={() => {
                openContactUsModal(label);
                onClick?.();
            }}
        >
            {text ? i18nFilter()(text) : children}
        </Button>
    );
};

export default ContactUsButton;
